// angular
import { Component, input } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgClass } from '@angular/common';
// components
import { CardPropertySkeletonComponent } from '../../card-property/card-property-skeleton/card-property-skeleton.component';

@Component({
  selector: 'pwj-supplier-card-skeleton',
  standalone: true,
  imports: [NgxSkeletonLoaderModule, CardPropertySkeletonComponent, NgClass],
  templateUrl: './supplier-card-skeleton.component.html',
  styleUrl: './supplier-card-skeleton.component.scss',
})
export class SupplierCardSkeletonComponent {
  // inputs
  count = input<number>(1);
  containerClasses = input<string>();

  public counter(i: number) {
    return new Array(i);
  }
}
